export default "__VITE_ASSET__db0e8a40__"